import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { StratoButton } from "@/components/common/StratoButton";
import { Reveal } from "@/components/common/Reveal";
import { QUOTE_JOURNEY } from "@/content/homeContent";

export const QuotePreview = () => {
  return (
    <Section id="quote-preview-section" tone="offwhite">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionHeading
              microLabel={QUOTE_JOURNEY.microLabel}
              title={QUOTE_JOURNEY.title}
              description={QUOTE_JOURNEY.description}
            />
          </Reveal>
          <Reveal delay={0.1}>
            <StratoButton
              as={Link}
              to="/preventivo"
              data-testid="quote-preview-cta"
              className="mt-8 px-6 py-3.5 text-[15px]"
            >
              {QUOTE_JOURNEY.cta}
              <ArrowRight className="h-4 w-4" />
            </StratoButton>
          </Reveal>
        </div>

        {/* elegant vertical timeline */}
        <div className="lg:col-span-8">
          <ol className="relative">
            {QUOTE_JOURNEY.steps.map((step, i) => (
              <Reveal key={step.n} delay={i * 0.04}>
                <li
                  data-testid={`quote-preview-step-${i}`}
                  className="relative grid grid-cols-1 gap-2 border-l border-strato-gray-200 pb-8 pl-8 last:border-l-transparent last:pb-0 sm:grid-cols-12 sm:items-baseline sm:gap-6"
                >
                  <span className="absolute -left-[7px] top-1 h-3.5 w-3.5 rounded-full border border-strato-gray-300 bg-strato-offwhite">
                    <span className="absolute inset-1 rounded-full bg-strato-blue" />
                  </span>
                  <div className="sm:col-span-4">
                    <span className="strato-micro text-strato-blue">STEP {step.n}</span>
                    <h3 className="mt-1 font-display text-xl font-medium tracking-[-0.01em] text-strato-graphite">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-sm leading-[1.6] text-muted-foreground sm:col-span-8">
                    {step.desc}
                  </p>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </Section>
  );
};
